import { useEffect } from 'react';
import './Notification.css';

export interface NotificationProps {
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message: string;
  duration?: number;
  onClose: () => void;
}

export const Notification = ({
  type,
  title,
  message,
  duration = 5000,
  onClose,
}: NotificationProps) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  };

  return (
    <div className="notification-overlay" onClick={onClose}>
      <div
        className={`notification notification-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="notification-icon">
          <span className="material-symbols-outlined">{getIcon()}</span>
        </div>
        <div className="notification-content">
          <h4 className="notification-title">{title}</h4>
          <p className="notification-message">{message}</p>
        </div>
        <button className="notification-close" onClick={onClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>
  );
};
